export default function ImportFormatHint() {
  return (
    <div className="rounded-md border bg-muted px-3 py-2 text-xs">
      <p className="mb-2 font-medium text-foreground">File format</p>

      <ul className="mb-2 space-y-1 text-muted-foreground">
        <li className="flex gap-2">
          <span className="flex-shrink-0">•</span>
          <span><strong className="font-medium">CSV only</strong> — export from Excel or Google Sheets via "Save as CSV". Excel files (.xlsx) are rejected.</span>
        </li>
        <li className="flex gap-2">
          <span className="flex-shrink-0">•</span>
          <span><strong className="font-medium">Required columns:</strong> product id (any header containing "produc", e.g., "Product ID"), "Customer", salesman (header containing "salesman"), and one per month (MM/YY, e.g., 01/26). Other columns (like SKU) are ignored.</span>
        </li>
        <li className="flex gap-2">
          <span className="flex-shrink-0">•</span>
          <span><strong className="font-medium">Values:</strong> whole units; thousands separators are fine; blank cells mean no forecast.</span>
        </li>
        <li className="flex gap-2">
          <span className="flex-shrink-0">•</span>
          <span><strong className="font-medium">Skipped rows:</strong> subtotals ("Tổng số …"), blank product id or customer.</span>
        </li>
        <li className="flex gap-2">
          <span className="flex-shrink-0">•</span>
          <span><strong className="font-medium">Product ids</strong> must already exist in Atlas; unknown ids are reported and skipped.</span>
        </li>
        <li className="flex gap-2">
          <span className="flex-shrink-0">•</span>
          <span><strong className="font-medium">Customer names</strong> not found are created automatically — check the sheet for typos first.</span>
        </li>
        <li className="flex gap-2">
          <span className="flex-shrink-0">•</span>
          <span><strong className="font-medium">Salesman name</strong> is matched against Atlas users to set the customer's PIC; unmatched names import without a PIC (warning shown). Existing PICs are never changed.</span>
        </li>
        <li className="flex gap-2">
          <span className="flex-shrink-0">•</span>
          <span><strong className="font-medium">Re-import is safe:</strong> existing cells are updated, not duplicated.</span>
        </li>
      </ul>

      <p className="mb-1 font-medium text-foreground">Example header:</p>
      <div className="overflow-x-auto rounded-md border bg-background p-2">
        <code className="font-mono text-xs text-muted-foreground">Product ID,SKU,Customer,Salesman,01/26,02/26,…</code>
      </div>
    </div>
  );
}
